import { createCollectionReducer } from "reducers/account/collections";
import { selectIsSynced } from "reducers/account/requests";

const TYPE = "translations";

export default createCollectionReducer(TYPE);

export const selectTranslations = state => state.account.translations;
export const selectFlowTranslationByLocale = (state, localeId) =>
  Object.values(selectTranslations(state) || {}).find(
    t => t.locale_id === localeId
  );
export const selectAreTranslationsSynced = state => selectIsSynced(state, TYPE);
